import SearchIcon from "components/icons/SearchIcon";
import Colors from "assets/Colors";
import { Col, Row, Input, Menu, Button, Dropdown } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import CustomDatePicker from "components/common/CustomDatePicker";
import CustomSelector from "components/common/Selector";
import useScreenSize from "hooks/useScreenSize";
import { useTranslation } from "react-i18next";
import s from "../../../styles/TopMenu.styles";

function TopMenu({
  data = [],
  billType,
  setBillType,
  terminal,
  setTerminal,
  users,
  setUsers,
  date,
  setDate,
  setSearch,
  loading,
  disabled,
  getImageGraph,
  exportFileExcel,
}) {
  const { width } = useScreenSize();
  const { t } = useTranslation();

  const dataType = [
    {
      name: t("general.all"),
      value: "all",
    },
    {
      name: t("components.OperationsSales.topMenu.fac"),
      value: "fac",
    },
    {
      name: t("components.OperationsSales.topMenu.faccomplete"),
      value: "faccomplete",
    },
    {
      name: t("components.OperationsSales.topMenu.facsimple"),
      value: "facsimple",
    },
    {
      name: t("components.OperationsSales.topMenu.vou"),
      value: "vou",
    },
    {
      name: t("components.OperationsSales.topMenu.cre"),
      value: "cre",
    },
  ];  

  const terminals = data.reduce((acc, item) => {
    if (!acc.includes(item.invoiceSerial)) {
      acc.push(item.invoiceSerial);
    }
    return acc;
  }, []);

  const terminalsTransform = terminals.map((item) => ({
    name: item,
    value: item,
  }));
  terminalsTransform.unshift({
    name: t("general.all"),
    value: "all",
  });

  const userss = data.reduce((acc, item) => {
    if (!acc.includes(item.billingUserName)) {
      acc.push(item.billingUserName);
    }
    return acc;
  }, []);

  const userssTransform = userss.map((item) => ({ name: item, value: item }));
  userssTransform.unshift({
    name: t("general.all"),
    value: "all",
  });

  const onChangeBillType = (e) => {
    setBillType(e);
  };

  const onChangeTerminal = (e) => {
    setTerminal(e);
  };

  const onChangeUsers = (e) => {
    setUsers(e);
  };

  const menu = (
    <Menu style={{ padding: "8px" }}>
      <Menu.Item>
        <Button
          type="link"
          icon={<DownloadOutlined />}
          size="large"
          style={{ color: "#000" }}
          disabled={disabled}
          onClick={() => exportFileExcel()}
        >
          Excel
        </Button>
      </Menu.Item>
      <Menu.Item>
        <Button
          type="link"
          icon={<DownloadOutlined />}
          size="large"
          style={{ color: "#000" }}
          disabled={disabled}
          onClick={() => getImageGraph()}
        >
          Pdf
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <s.Container
      style={{
        display: "block",
      }}
    >
      <Row gutter={[10, 10]}>
        <Col xs={24} sm={24} md={24} lg={12} xl={3}>
          <s.Title>
            {t("components.OperationsSales.topMenu.invoiceNumber")}
          </s.Title>
          <Input
            disabled={loading}
            placeholder={t("general.search")}
            type="number"
            style={{
              borderColor: Colors.background_dividers,
              height: "40px",
              maxWidth: "340px",
              // minWidth: "200px",
              width: "100%",
              marginRight: "10px",
              marginBottom: "10px",
            }}
            prefix={<SearchIcon />}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
        <Col
          xs={24}
          md={24}
          lg={12}
          xl={12}
          style={{
            display: "flex",
            justifyContent: width > 990 ? "center" : "start",
          }}
        >
          <CustomDatePicker
            loading={loading}
            value={date?.value}
            onChange={(value, periodType, range) => {
              setDate({ value, periodType, range });
            }}
          />
        </Col>
        <Col
          xs={24}
          md={24}
          lg={24}
          xl={9}
          style={{
            display: "flex",
            justifyContent: width < 768 ? "start" : "start",
            margin: width < 768 ? "-3px" : "-3px 0px 15px 0px",
            marginTop: "-3px",
          }}
        >
          <Row>
            <Col style={{ marginRight: "10px" }}>
              <s.SubTitle>
                {t("components.OperationsSales.topMenu.claspTyper")}
              </s.SubTitle>
              <CustomSelector
                disabled={loading}
                placeholder={t("components.OperationsSales.topMenu.fac")}
                border={Colors.text_secondary}
                options={dataType}
                style={{ width: "128px" }}
                value={billType}
                onChange={onChangeBillType}
              />
            </Col>
            <Col style={{ marginRight: "10px" }}>
              <s.SubTitle>
                {t("components.OperationsSales.topMenu.terminal")}:
              </s.SubTitle>
              <CustomSelector
                disabled={loading}
                placeholder={t("components.OperationsSales.topMenu.terminal")}
                border={Colors.text_secondary}
                options={terminalsTransform}
                style={{ width: "107px" }}
                value={terminal}
                onChange={onChangeTerminal}
              />
            </Col>
            <Col style={{ marginRight: "10px" }}>
              <s.SubTitle>
                {t("components.OperationsSales.topMenu.users")}
              </s.SubTitle>
              <CustomSelector
                disabled={loading}
                placeholder={t("components.OperationsSales.topMenu.users")}
                border={Colors.text_secondary}
                options={userssTransform}
                style={{ width: "128px" }}
                value={users}
                onChange={onChangeUsers}
              />
            </Col>
            <Col>
              <s.SubTitle>&nbsp;</s.SubTitle>
              <Dropdown disabled={loading} overlay={menu}>
                <Button
                  style={{
                    height: "40px",
                    width: "40px",
                    borderColor: Colors.icon_secondary,
                  }}
                  icon={<DownloadOutlined />}
                />
              </Dropdown>
            </Col>
          </Row>
        </Col>
      </Row>
    </s.Container>
  );
}

export default TopMenu;
